module.exports = __webpack_public_path__ + "img/writing_sudoku.a2279edf.svg";